import axios from 'axios';

/**
 * Bare axios client for auth/session endpoints (login, logout, refresh).
 * Refresh token is httpOnly cookie only — never read or written in JS.
 */
const authClient = axios.create({
  baseURL: process.env.BASE_URL,
  withCredentials: true,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

export const loginRequest = (credentials) =>
  authClient.post('/web_user/login', credentials);

export const logoutRequest = () => authClient.post('/web_user/logout');

export const refreshSessionRequest = () =>
  authClient.post(process.env.REACT_APP_REFRESH_PATH || '/refresh', {});

export const createCompanyContextRequest = async (companyId, accessToken) => {
  const response = await fetch(`/companies/${encodeURIComponent(companyId)}/context`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: '{}',
  });

  const text = await response.text();
  const trimmed = text.replace(/^\uFEFF/, '').trim();
  let data = text;

  if (
    trimmed.startsWith('{') ||
    trimmed.startsWith('[') ||
    trimmed.startsWith('"')
  ) {
    try {
      data = JSON.parse(trimmed);
    } catch {
      data = text;
    }
  }

  if (!response.ok) {
    const error = new Error(`Company context failed (${response.status})`);
    error.response = {
      status: response.status,
      data,
    };
    throw error;
  }

  return {
    data,
    status: response.status,
    headers: {
      'x-access-token': response.headers.get('x-access-token'),
      'x-auth-token': response.headers.get('x-auth-token'),
      authorization: response.headers.get('authorization'),
    },
  };
};
